var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAssets = function SvgAssets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2 0h20v20H-2z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.033)",
    stroke: "currentColor",
    strokeWidth: 1.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.848 5.202a2.117 2.117 0 0 1 1.15-1.518L7.527.932C8.564.416 9.81.809 10.309 1.81l.004.01 1.316 2.673"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.85,
    y: 4.101,
    width: 14.3,
    height: 11.3,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.15 8.101v3.3H10a1.146 1.146 0 0 1-1.15-1.15v-1A1.146 1.146 0 0 1 10 8.101h5.15Z",
    fill: "#FFF"
  })))));
};
export default SvgAssets;